import { atom } from 'jotai';
import { detailedPricingUsuallySpendAtom } from './detailed-pricing';
import { couplesUsuallySpendAtom } from './pricing';
import { vendorAtom } from './shared';

export const hasCouplesUsuallySpendAtom = atom((get) => {
	const vendor = get(vendorAtom);
	const couplesUsuallySpendDetailedPricing = get(
		detailedPricingUsuallySpendAtom,
	);
	const couplesUsuallySpend = get(couplesUsuallySpendAtom);
	const categoryCode = vendor?.categoryCode || '';
	const hasCouplesUsuallySpend = Boolean(
		categoryCode === 'REC'
			? couplesUsuallySpend
			: couplesUsuallySpendDetailedPricing,
	);

	return hasCouplesUsuallySpend;
});
